import { MultilinkStoryblok } from "@/types/sb-component-types"

export const resolveSbLink = (
  link: MultilinkStoryblok,
  currentLocale: string,
) => {
  const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE

  switch (link.linktype) {
    case "url":
      return link.url
    case "story":
      return currentLocale === defaultLocale
        ? `/${currentLocale}/${link.cached_url}`
        : link.cached_url
    case "asset":
      return link?.filename
    case "email":
      return `mailto:${link.email}`
    default:
      return "/"
  }
}
